module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0077.jpg?v=fea86fd2";